
  <div class="wp-overlay">
    <div class="wp-modal wp-center">
      <h4>Download Zip</h4>
      <div style="display:block; width:100%; padding: 1rem;">
        <p>
          Status: {{status}}
        </p>
        <div class="progress" *ngIf="progress > 0">
          <div class="progress-bar" [style.width]="progress + '%'"></div>
        </div>

      </div>
    </div>
  </div>
  


// WEBPACK FOOTER //
// ./src/app/file.zip.download.component.ts.FileZipDownload.html